import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "icon"];

  toggle() {
    const mostrar = this.inputTarget.type === "password";

    this.inputTarget.type = mostrar ? "text" : "password";
    this.iconTarget.classList.toggle("bi-eye", !mostrar);
    this.iconTarget.classList.toggle("bi-eye-slash", mostrar);
  }
}
